// extracted by mini-css-extract-plugin
module.exports = {"column":"ContentWithMenu_column__3fXn_","layout":"ContentWithMenu_layout__ERiZZ","rest":"ContentWithMenu_rest__3J3bD","menu":"ContentWithMenu_menu__dieIv"};